export enum EnumMaxLengthFields {
  A = 1,
  Codigo = 20,
  CodigoAux = 20,
  Descripcion = 40,
  DescripcionLarga = 3000,
  CodigoEstado = 5,
  Costo = 16,
  Precio = 16,
  Cantidad = 16,
  TipoPorcentaje = 2,
  Url = 200,
  Expresion = 100,
  Referencia = 100,
  Fecha = 30,
  RazonSocial = 100,
  Direccion = 80,
  Colonia = 30,
  Telefono = 30,
  RFC = 15,
  CP = 6,
  CMIC = 40,
  Fax = 30,
  IMSS = 10,
  Infonavit = 20,
  Mail = 50,
  NombreVendedor = 40,
  NombreCliente = 1000,
  NombreResponsable = 40,
  NombreEstado = 30,
  Cargo = 40,
  Contacto = 80,
  Observacion = 500,
  Celular = 40,
  Pagina = 80,
  Renglon = 40,
  CHs = 100
}
